import axios from 'axios'
import store from '../../store/index'

const state = {
  client: {},
  clients: [],
}

const mutations = {
  client_data (state, client) {
    state.client = client
  },
  init_client (state, clients) {
    state.clients = clients
  },
  new_client (state, client) {
    let theIndex = null
    state.clients.filter((item, index) => {
      if (item.clientId === client.clientId) {
        theIndex = index
      }
    })
    if (theIndex !== null) {
      return
    }
    state.clients.unshift(client)
  },
  remove_client (state, clientId) {
    let theIndex = null
    state.clients.filter((item, index) => {
      if (item.clientId === clientId) {
        theIndex = index
      }
    })
    if (theIndex !== null) {
      state.clients.splice(theIndex, 1)
    }
  },
  update_client (state, client) {
    let theIndex = null
    if (client.images === null) {
      client.images = []
    }
    state.clients.filter((item, index) => {
      if (item.clientId === client.clientId) {
        theIndex = index
      }
    })
    if (theIndex !== null) {
      state.clients.splice(theIndex, 1, client)
    }
  },
  update_client_period (state, { clientId, period }) {
    const client = state.clients.find(c => c.clientId === clientId)
    if (client) {
      client.period = period
    }
  },
}

const actions = {
  clientUpdate ({ commit }, client) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/clients?clientId=' + client.clientId,
        data: client.message,
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          // commit('client_data', resp.data.message)
          commit('update_client', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  clientCreate ({ commit }, client) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/clients',
        data: client,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('new_client', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  clientsRequest ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/clients',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('init_client', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  clientsDashboardRequest ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/clients/dashboard',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  clientsLocationRequest ({ commit }, locationId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/clients/location?locationId=' + locationId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          // commit('init_client', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  clientsDelete ({ commit }, clientId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/clients?clientId=' + clientId,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
